import React from "react";
import { Box, Typography, IconButton, Stack, Link } from "@mui/material";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import ArrowForwardIosRoundedIcon from "@mui/icons-material/ArrowForwardIosRounded";
import SparklesIcon from "@mui/icons-material/AutoAwesome"; // Representing sparkles
import ChatItemContainer from "./ChatItemContainer";

const suggestions = [
  "How many rooms were sold today.",
  "What is my total room revenue",
  "How much revenue lost due to no shows and cancellations",
];

const NewChatScreen = ({ onSuggestionSelect }) => {
  return (
    <Box
      height="100%"
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      textAlign="center"
      px={2}
    >
      {/* Logo */}
      <SparklesIcon sx={{ fontSize: 50, mb: 1 }} />

      {/* Title */}
      <Typography variant="h4" fontWeight="bold" gutterBottom>
        Stayflexi
      </Typography>
      <Typography variant="h6" color="text.secondary" gutterBottom>
        Flexi AI
      </Typography>

      {/* Subtitle */}
      <Typography variant="body2" color="text.secondary" mb={4}>
        How can Stayflexi Flexi AI help you?
      </Typography>

      {/* Suggestions */}
      <Stack spacing={2} width="100%" maxWidth="420px">
        {suggestions.map((text, idx) => (
          <ChatItemContainer onClick={() => onSuggestionSelect(text)}>
            <Box display="flex" alignItems="center" flex={1}>
              <EditOutlinedIcon fontSize="small" sx={{ mr: 1 }} />
              <Typography
                fontSize={14}
                color="text.secondary"
                flex={1}
                textAlign={"left"}
              >
                {text}
              </Typography>
            </Box>
            <ArrowForwardIosRoundedIcon
              sx={{ fontSize: 14, color: "text.secondary" }}
            />
          </ChatItemContainer>
        ))}
      </Stack>

      {/* See more prompts */}
      {/* <Box mt={3} display="flex" alignItems="center">
        <Link href="#" underline="hover" fontSize={14} fontWeight={500}>
          See more prompts
        </Link>
        <ArrowForwardIosRoundedIcon
          sx={{ fontSize: 14, ml: 0.5, color: "text.secondary" }}
        />
      </Box> */}
    </Box>
  );
};

export default NewChatScreen;
